import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Menu, X, LogOut } from 'lucide-react';

export default function Navbar() {
  const { user, login, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const isLanding = location.pathname === '/';
  const isDashboard = location.pathname.startsWith('/dashboard');
  const isApply = location.pathname === '/apply';

  if (isDashboard || isApply) return null;

  return (
    <nav className="glass-nav fixed top-0 left-0 right-0 z-50" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="logo-link">
          <img src="/krieger-logo.jpg" alt="Krieger" className="h-8 w-8 object-contain" />
          <span className="font-['Cabinet_Grotesk'] text-xl font-bold tracking-[0.15em] text-slate-900">
            KRIEGER
          </span>
          <span className="text-[10px] tracking-[0.2em] uppercase text-slate-400 font-semibold hidden sm:inline">
            Real Estate
          </span>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {isLanding && (
            <>
              <a href="#commission" className="text-sm text-slate-500 hover:text-slate-900 transition-colors" data-testid="nav-commission">Commission</a>
              <a href="#commercial" className="text-sm text-slate-500 hover:text-slate-900 transition-colors" data-testid="nav-commercial">Commercial</a>
              <a href="#calculator" className="text-sm text-slate-500 hover:text-slate-900 transition-colors" data-testid="nav-calculator">Calculator</a>
              <a href="#campaigns" className="text-sm text-slate-500 hover:text-slate-900 transition-colors" data-testid="nav-campaigns">Marketing</a>
            </>
          )}
          <Link to="/blog" className="text-sm text-slate-500 hover:text-slate-900 transition-colors" data-testid="nav-blog">Blog</Link>
          {user ? (
            <div className="flex items-center gap-4">
              <Link
                to="/dashboard"
                className="text-sm bg-[#002FA7] text-white px-5 py-2 rounded-full font-medium hover:bg-[#0040D6] transition-colors"
                data-testid="nav-dashboard-btn"
              >
                Dashboard
              </Link>
              <button
                onClick={logout}
                className="text-sm text-slate-400 hover:text-slate-700 transition-colors flex items-center gap-1"
                data-testid="nav-logout-btn"
              >
                <LogOut size={14} /> Logout
              </button>
            </div>
          ) : (
            <div className="flex items-center gap-5">
              <Link
                to="/apply"
                className="text-sm text-slate-500 hover:text-slate-900 transition-colors"
                data-testid="nav-apply-link"
              >
                Apply Now
              </Link>
              <button
                onClick={login}
                className="text-sm bg-[#002FA7] text-white px-5 py-2 rounded-full font-medium hover:bg-[#0040D6] transition-colors"
                data-testid="nav-login-btn"
              >
                Agent Login
              </button>
            </div>
          )}
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden text-slate-700"
          onClick={() => setMenuOpen(!menuOpen)}
          data-testid="mobile-menu-toggle"
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden border-t border-slate-100 bg-white px-6 py-4 space-y-3" data-testid="mobile-menu">
          {isLanding && (
            <>
              <a href="#commission" onClick={() => setMenuOpen(false)} className="block text-sm text-slate-500 hover:text-slate-900">Commission</a>
              <a href="#commercial" onClick={() => setMenuOpen(false)} className="block text-sm text-slate-500 hover:text-slate-900">Commercial</a>
              <a href="#campaigns" onClick={() => setMenuOpen(false)} className="block text-sm text-slate-500 hover:text-slate-900">Marketing</a>
            </>
          )}
          <Link to="/blog" onClick={() => setMenuOpen(false)} className="block text-sm text-slate-500 hover:text-slate-900">Blog</Link>
          {user ? (
            <>
              <Link to="/dashboard" onClick={() => setMenuOpen(false)} className="block text-sm text-slate-800 font-medium">Dashboard</Link>
              <button onClick={() => { logout(); setMenuOpen(false); }} className="text-sm text-slate-500 hover:text-slate-800 flex items-center gap-1">
                <LogOut size={14} /> Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/apply" onClick={() => setMenuOpen(false)} className="block text-sm text-slate-500 hover:text-slate-900">Apply Now</Link>
              <button onClick={() => { login(); setMenuOpen(false); }} className="text-sm text-[#002FA7] font-medium">Agent Login</button>
            </>
          )}
        </div>
      )}
    </nav>
  );
}
